import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Home from "pages/Home";
import Contact from "pages/Contact";
import Source from "pages/Source";
import Year from "pages/Year";
import Country from "pages/Country";
import Ethnicity from "pages/Ethnicity";
import Age from "pages/Age";
import Auth from "pages/Auth";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <Router>
    <Route path="/" exact component={Home} />
    <Route exact path="/contact/:slug/:id" component={Contact} />
    <Route exact path="/contact" component={Contact} />
    <Route path="/source" component={Source} />
    <Route path="/year" component={Year} />
    <Route path="/age" component={Age} />
    <Route path="/country" component={Country} />
    <Route path="/ethnicity" component={Ethnicity} />
    <Route path="/auth" component={Auth} />
  </Router>,
  document.getElementById("root")
);

serviceWorker.unregister();
